import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NotificationService } from 'src/app/_services/notification.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { UserService } from 'src/app/_services/user.service';
import { NotificationI18nService } from '../../core/util/notification-i18n.service';

@Component({
  selector: 'app-confirm-otp-dialog',
  templateUrl: './confirm-otp-dialog.component.html',
  styleUrls: ['./confirm-otp-dialog.component.css']
})
export class ConfirmOtpDialogComponent extends UnsubscribeOnDestroy implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmOtpDialogComponent>
    ,@Inject(MAT_DIALOG_DATA) public data: any,
     private userService: UserService,
     private token: TokenStorageService,
     private _notificationI18n: NotificationI18nService
  ) {
    super();
  }
  form: FormGroup = new FormGroup( {
    codigoSeguridad: new FormControl("", [Validators.required, Validators.pattern("[0-9]{6}")])
  }, {});
  otpGenerada :boolean= false;
  tipo: string = '';
  ngOnInit(): void {
   this.openGenerateOtp()
  }
  finish(){   
    this.validarCodigoSeguridad();
  }

  cancel(){
    this.dialogRef.close({result:'Cancelar'});
  }
  validarCodigoSeguridad(): Boolean{
    var retorno:Boolean = false;
    this.userService.validarCodigoSeguridad(this.token, this.form.value.codigoSeguridad)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: data => {
        if (data.status === "653") {
          this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_CODIGO_DE_SEGURIDAD_ES_VALIDO', 50000);
          this.dialogRef.close({result: 'Confirmar'});
        }
        else{
          this._notificationI18n.errorDynamic(data.message, 50000);
          if (data.status === "656") {
            setTimeout(() => {this.logout();}, 5000);
          }
        }
      },
      error: (err) => {
          this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_VALIDAR_EL_CODIGO_DE_SEGURIDAD', 50000);
      }
    });
    return retorno;
  }
  logout(): void {
    this.token.signOut();
    window.location.reload();
  } 

  
  openGenerateOtp(){
    var retorno:Boolean = false;
    this.userService.generarCodigoSeguridad(this.token, this.data.tipo)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: data => {
        if (data.status === "652") {

          this._notificationI18n.success(
            this.data.tipo === 'MOVIL'
              ? 'NOTIFICATION.MESSAGE.OTP_ENVIADO_DISPOSITIVO'
              : 'NOTIFICATION.MESSAGE.OTP_ENVIADO_EMAIL',
            50000
          );
          this.otpGenerada = true;
        }
        else{
          this.otpGenerada  = false;
        }
      },
      error: (err) => {
          this._notificationI18n.error(
            this.data.tipo === 'MOVIL'
              ? 'NOTIFICATION.MESSAGE.OTP_NO_ENVIADO_DISPOSITIVO'
              : 'NOTIFICATION.MESSAGE.OTP_NO_ENVIADO_EMAIL',
            50000
          );
          this.otpGenerada  = false;
          this.dialogRef.close({result:'Cancelar'});
      }
    });
  }
}
